module.exports = __webpack_public_path__ + "static/media/icon-coins.2078bee5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/icon-coins.svg
// module id = 1006
// module chunks = 0